'use strict';

(function () {
    'use strict';

    appRun.$inject = ['routerHelper'];
    angular.module('app.dashboard').run(appRun);

    function appRun(routerHelper) {
        'ngInject';

        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [{
            state: 'dashboard',
            config: {
                url: '/dashboard',
                template: '<div style="padding:1em;" translate-namespace="dashboard"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><ol class="breadcrumb pull-left"><li ng-repeat="breadcrumb in $ctrl.app.breadcrumbs"><a href="{{breadcrumb.url}}">{{breadcrumb.label | translate}}</a></li><li translate>.Dashboard</li></ol><div class="pull-right"><login-widget></login-widget></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-6 col-lg-4"><the-city-widget css-class="dashboard-panel--v2"></the-city-widget><the-citizens-widget css-class="dashboard-panel--v2"></the-citizens-widget><the-library-widget css-class="dashboard-panel--v2"></the-library-widget><budget-widget css-class="dashboard-panel--v2"></budget-widget></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-4"><urban-environment-widget css-class="dashboard-panel--v3" line-color="#fff"></urban-environment-widget><sound-levels-widget css-class="dashboard-panel--v7" line-color="#fff"></sound-levels-widget></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-4"><crowd-estimation-widget css-class="dashboard-panel--v6" line-color="#fff"></crowd-estimation-widget><traffic-estimation-widget css-class="dashboard-panel--v8" line-color="#fff"></traffic-estimation-widget></div></div></div>',
                controllerAs: '$ctrl',
                controller: ['$controller', function controller($controller) {
                    'ngInject';

                    var appController = $controller('AppController');
                    this.app = appController;
                }]
            }
        }];
    }
})();